import { render, staticRenderFns } from "./nearAccidentInfo.vue?vue&type=template&id=2707f95b"
import script from "./nearAccidentInfo.vue?vue&type=script&lang=js"
export * from "./nearAccidentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2707f95b')) {
      api.createRecord('2707f95b', component.options)
    } else {
      api.reload('2707f95b', component.options)
    }
    module.hot.accept("./nearAccidentInfo.vue?vue&type=template&id=2707f95b", function () {
      api.rerender('2707f95b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/near/nearAccidentInfo.vue"
export default component.exports